<div class="card_journey">
  <div class="container">
    
    <div class="d-flex align-items-center justify-content-between my-2">
      <div class="d-flex align-items-center">
        <img class="mr-2" src="../../../../assets/Transaction.png" />
        <span class="accordian_heading">Transaction Details</span>
      </div>
      <div style="cursor: pointer;"><img src="../../../../assets/Vector.png" (click)="hideTooltip()" /></div>
    </div>

    <hr class="heading_divider" />
    <!-- <div class="row mt-3 ml-1">
      <div class="col-10 text-start"><img class="mr-2" src="../../../../assets/Transaction.png" /><span class="accordian_heading">Transaction Details</span></div>
      <div class="col-2 text-end" style="cursor: pointer;"><img src="../../../../assets/Vector.png" (click)="hideTooltip()" /></div>
      <hr class="heading_divider mt-2 mr-3" />
    </div> -->
    
    <div class="accordian_inside_heading mx-2">{{transactionName}}</div>

    <div class="panel-group my-3" id="accordion" *ngIf="transactionData">
      <div class="panel panel-default panel_outlay mt-2" *ngFor="let data of transactionData;let i=index">
        <div class="panel-heading" style="margin: 10px 0;">
          <span class="panel-title mt-2">
            <a data-toggle="collapse" class="accordion-toggle collapsed inner_heading" data-parent="#accordion"
              [attr.href]="'#collapse'+i">
              {{data.Key}}
            </a>
          </span>
        </div>

        <div [attr.id]="'collapse'+i" class="panel-collapse collapse in ml-2 mr-2" data-parent="#accordion">
          <hr class="heading_divider mt-2 mr-3" />
          <div class="panel-body">
            <div class="row" *ngFor="let obj of data?.Value">
              <div class="col-12 d-flex">
                <div class="col-6 trans_data_key text-end">{{obj.Key}}</div>
                <span class="pl-0">:</span>
                <div class="col-6 trans_data_value text-start">{{obj.Value}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ng-template #elseBlock>
        <div class="text-center">
          <h3>No Data Found</h3>
        </div>
      </ng-template> -->
  </div>
</div>